export default __webpack_public_path__ + "static/media/honeybee.6c279eaa.jpg";